if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.hasChildNodes()) {
        this.init();
      }
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener(
            'submit',
            this.handleSubmit.bind(this)
          );
        }
      }
    }


    /**
     * Liest TTI-Vorbestellinformationen aus dem Formular.
     *
     * Priorität:
     * 1. Bereits vorhandene Line Item Properties
     * 2. data-Attribute
     * 3. Vorbestellen-Button + sichtbares Lieferdatum
     */
    getTTIPreorderData() {
      const result = {
        preorder: false,
        date: ''
      };


      /*
       * 1. Bereits vorhandene Shopify Properties.
       */
      const statusInput = this.form.querySelector(
        'input[name="properties[Lieferstatus]"]'
      );

      const dateInput = this.form.querySelector(
        'input[name="properties[Voraussichtlich lieferbar]"]'
      );


      if (
        statusInput &&
        String(statusInput.value).toLowerCase() === 'vorbestellung'
      ) {
        result.preorder = true;
      }


      if (
        dateInput &&
        dateInput.value
      ) {
        result.date = String(dateInput.value).trim();
      }


      /*
       * Wenn wir bereits alles wissen, sind wir fertig.
       */
      if (
        result.preorder &&
        result.date
      ) {
        return result;
      }


      /*
       * 2. Optional vorbereitete data-Attribute.
       * Dadurch bleibt der Code auch für spätere Erweiterungen nutzbar.
       */
      const ttiStatus =
        this.form.dataset.ttiStatus ||
        this.dataset.ttiStatus ||
        '';

      const ttiDate =
        this.form.dataset.ttiRestockDate ||
        this.dataset.ttiRestockDate ||
        '';


      if (
        String(ttiStatus).toLowerCase() === 'preorder'
      ) {
        result.preorder = true;
      }


      if (
        !result.date &&
        ttiDate
      ) {
        result.date =
          this.formatTTIDate(ttiDate);
      }


      /*
       * 3. Fallback für Produktkarten / Schnellkauf.
       *
       * Bei unseren TTI-Vorbestellern heißt der Button
       * "Vorbestellen".
       */
      const submitButton =
        this.querySelector('[name="add"]');

      const buttonText =
        submitButton
          ? submitButton.textContent.trim().toLowerCase()
          : '';


      if (
        buttonText.includes('vorbestellen')
      ) {

        /*
         * Datum aus der Produktkarte bzw. Produktansicht lesen.
         */
        const scope =
          this.closest('product-card') ||
          this.closest('.card') ||
          this.closest('.js-product') ||
          this.closest('.product') ||
          this.parentElement;


        const scopeText =
          scope
            ? scope.textContent
            : '';


        const dateMatch =
          scopeText.match(
            /(?:voraussichtlich\s+ab\s+)?(\d{2}\.\d{2}\.\d{4})/i
          );


        if (
          dateMatch &&
          dateMatch[1]
        ) {
          result.preorder = true;

          if (!result.date) {
            result.date =
              dateMatch[1];
          }
        }
      }


      return result;
    }


    /**
     * yyyy-mm-dd -> dd.mm.yyyy
     * Bereits deutsches Datum bleibt unverändert.
     */
    formatTTIDate(value) {
      if (!value) return '';

      const stringValue =
        String(value).trim();


      if (
        /^\d{2}\.\d{2}\.\d{4}$/.test(stringValue)
      ) {
        return stringValue;
      }


      const match =
        stringValue.match(
          /^(\d{4})-(\d{2})-(\d{2})$/
        );


      if (match) {
        return (
          match[3] +
          '.' +
          match[2] +
          '.' +
          match[1]
        );
      }


      return stringValue;
    }


    /**
     * Erzwingt vorhandene Properties im FormData
     * und ergänzt TTI-Vorbestellinformationen.
     */
    prepareFormData(formData) {

      /*
       * Alle im Formular vorhandenen Shopify
       * Line Item Properties explizit übernehmen.
       */
      this.form
        .querySelectorAll(
          'input[name^="properties["], ' +
          'select[name^="properties["], ' +
          'textarea[name^="properties["]'
        )
        .forEach((input) => {

          if (
            !input.name ||
            input.disabled
          ) {
            return;
          }


          if (
            input.type === 'checkbox' &&
            !input.checked
          ) {
            return;
          }


          if (
            input.type === 'radio' &&
            !input.checked
          ) {
            return;
          }


          formData.set(
            input.name,
            input.value
          );
        });


      /*
       * TTI-Vorbestellung zusätzlich absichern.
       */
      const tti =
        this.getTTIPreorderData();


      if (!tti.preorder) {
        return;
      }


      formData.set(
        'properties[Lieferstatus]',
        'Vorbestellung'
      );


      if (tti.date) {
        formData.set(
          'properties[Voraussichtlich lieferbar]',
          tti.date
        );
      }
    }


    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (
        evt.target.id ===
        'product-signup_form'
      ) {
        return;
      }


      evt.preventDefault();


      this.submitBtn =
        this.querySelector('[name="add"]');


      if (!this.submitBtn) {
        return;
      }


      if (
        this.submitBtn.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }


      if (
        theme.settings.vibrateOnATC &&
        window.navigator.vibrate
      ) {
        window.navigator.vibrate(100);
      }


      this.errorMsg = null;
      this.setErrorMsgState();


      /*
       * Add-to-Cart Button bis zum Abschluss deaktivieren.
       */
      this.submitBtn.setAttribute(
        'aria-disabled',
        'true'
      );

      this.submitBtn.classList.add(
        'is-loading'
      );


      /*
       * Shopify FormData erzeugen.
       */
      const formData =
        new FormData(this.form);


      /*
       * ROTESWERKZEUG / TTI:
       * Vorbestellinformationen jetzt explizit
       * in die tatsächlich gesendeten Daten schreiben.
       */
      this.prepareFormData(
        formData
      );


      let sections =
        'cart-icon-bubble';


      if (this.cartDrawer) {
        sections +=
          `,${this.cartDrawer
            .closest('.shopify-section')
            .id
            .replace('shopify-section-', '')}`;
      }


      formData.append(
        'sections_url',
        window.location.pathname
      );

      formData.append(
        'sections',
        sections
      );


      const fetchRequestOpts = {
        method: 'POST',

        headers: {
          Accept:
            'application/javascript',

          'X-Requested-With':
            'XMLHttpRequest'
        },

        body: formData
      };


      try {

        /*
         * Aktuellen Warenkorb vor dem Hinzufügen laden.
         */
        const oldCartResponse =
          await fetch(
            `${theme.routes.cart}.js`
          );


        if (!oldCartResponse.ok) {
          throw new Error(
            oldCartResponse.status
          );
        }


        const oldCartData =
          await oldCartResponse.json();


        /*
         * Produkt hinzufügen.
         */
        const response =
          await fetch(
            theme.routes.cartAdd,
            fetchRequestOpts
          );


        const data =
          await response.json();


        let error =
          typeof data.description === 'string'
            ? data.description
            : data.message;


        if (
          data.errors &&
          typeof data.errors === 'object'
        ) {
          error =
            Object.entries(
              data.errors
            ).map(
              (item) =>
                item[1].join(', ')
            );
        }


        if (data.status) {
          this.setErrorMsgState(
            error
          );
        }


        if (!response.ok) {
          throw new Error(
            response.status
          );
        }


        /*
         * Weiterleitung auf Warenkorbseite.
         */
        if (
          theme.settings.afterAtc ===
          'page'
        ) {

          setTimeout(() => {
            window.location.href =
              theme.routes.cart;
          }, 300);

        } else {

          /*
           * Warenkorb-Icon aktualisieren.
           */
          ProductForm.updateCartIcon(
            data
          );


          /*
           * Falls aus Quick Add Drawer hinzugefügt.
           */
          const quickAddDrawer =
            this.closest(
              'quick-add-drawer'
            );


          if (quickAddDrawer) {
            quickAddDrawer.addedToCart();
          }


          setTimeout(() => {

            /*
             * Cart Drawer aktualisieren.
             */
            if (this.cartDrawer) {

              this.cartDrawer.renderContents(
                data,

                !quickAddDrawer &&
                theme.settings.afterAtc ===
                  'drawer'
              );

            } else if (
              window.location.pathname ===
              theme.routes.cart
            ) {

              const cartItems =
                document.querySelector(
                  'cart-items'
                );


              if (cartItems) {

                if (
                  cartItems.dataset.empty ===
                  'true'
                ) {

                  window.location.reload();

                } else {

                  cartItems.refresh();
                }
              }
            }

          }, 700);
        }


        /*
         * Prüfen, ob Produkt vorher bereits
         * im Warenkorb vorhanden war.
         */
        const itemInOldCart =
          oldCartData.items.filter(
            (item) =>
              item.variant_id ===
              data.variant_id
          )[0];


        if (itemInOldCart) {

          this.dispatchEvent(
            new CustomEvent(
              'on:line-item:change',
              {
                bubbles: true,

                detail: {
                  variantId:
                    data.variant_id,

                  oldQuantity:
                    itemInOldCart.quantity,

                  newQuantity:
                    (
                      itemInOldCart.quantity ===
                      data.quantity
                    )
                      ? itemInOldCart.quantity
                      : data.quantity
                }
              }
            )
          );

        } else {

          this.dispatchEvent(
            new CustomEvent(
              'on:cart:add',
              {
                bubbles: true,

                detail: {
                  variantId:
                    data.variant_id
                }
              }
            )
          );
        }

      } catch (error) {

        console.log(error);


        this.dispatchEvent(
          new CustomEvent(
            'on:cart:error',
            {
              bubbles: true,

              detail: {
                error:
                  this.errorMsg
                    ?.textContent
              }
            }
          )
        );


        if (this.cartDrawer) {
          this.cartDrawer.refresh(
            true
          );
        }

      } finally {

        /*
         * Button wieder aktivieren.
         */
        this.submitBtn.classList.add(
          'is-success'
        );


        this.submitBtn.removeAttribute(
          'aria-disabled'
        );


        setTimeout(() => {

          this.submitBtn.classList.remove(
            'is-loading'
          );

          this.submitBtn.classList.remove(
            'is-success'
          );

        }, 1400);
      }
    }


    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {

      const cartIconBubble =
        document.getElementById(
          'cart-icon-bubble'
        );


      if (cartIconBubble) {
        cartIconBubble.innerHTML =
          response.sections[
            'cart-icon-bubble'
          ];
      }
    }


    /**
     * Shows/hides an error message.
     * @param {string} [error=false]
     */
    setErrorMsgState(error = false) {

      this.errorMsg =
        this.errorMsg ||
        this.querySelector(
          '.js-form-error'
        );


      if (!this.errorMsg) {
        return;
      }


      this.errorMsg.hidden =
        !error;


      if (error) {

        this.errorMsg.innerHTML =
          '';


        const errorArray =
          Array.isArray(error)
            ? error
            : [error];


        errorArray.forEach(
          (err, index) => {

            if (index > 0) {
              this.errorMsg.insertAdjacentHTML(
                'beforeend',
                '<br>'
              );
            }


            this.errorMsg.insertAdjacentText(
              'beforeend',
              err
            );
          }
        );
      }
    }
  }


  customElements.define(
    'product-form',
    ProductForm
  );
}